/**
 * This helper checks whether a value contains every attributes of a type T.
 *
 * @param value Any value of type T to be checked
 * @returns true or false
 */
export function isType(value) {
    return Object.keys(value).every((x) => {
        return x in value;
    });
}
//# sourceMappingURL=isType.js.map